import React from "react";

const Banner = ({title}) => {
  
  return (
    <div className="py-2 text-center text-black bg-yellow-400 lg:py-4">
      <p className="font-bold lg:text-lg">{title}</p>
    </div>
  );
};

export default Banner;
